<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    v-if="isSidebarActiveLocal"
    ref="frame"
    :class="isSidebarActiveLocal ? 'active' : ''" class="res-product-pop-cont">
    <div tabindex="1">
      <div class="reservation-popup">
        <div class="reservation-header">
          <h2>Reservation Completed</h2>
        </div>
        <div class="reservation-completed">
          <i class="far fa-calendar-check"></i>
          <h2>Your Reservation Completed Successfuly!</h2>
          <p>We sent details of this reservartion to your email.<br><br> -Restaurant Name- may contact you about this reservation, so please ensure your email and phone number are up to date.</p>
        </div>
        <div class="reservation-form">
          <div class="reservation-button close">Close</div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
    }
  },
  mounted () {},
  beforeDestroy () {
    this.isSidebarActiveLocal = false
  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        return
      }
      // const {name, id, price, complete_your_meal, description, restaurant_id, size, section, size_id, section_id, hasModifiers, quantity, photoUrl} = JSON.parse(JSON.stringify(this.dataProp))
      return true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
        }
      }
    }
  },
  methods: {
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    }
  }
}
</script>
